module.exports = __webpack_public_path__ + "static/img/CG.c83f71dc.svg";